import { FunctionComponent, ReactNode } from "react";

import { useParams } from "react-router-dom";

import { useApplications } from "../../api/apiQueries.ts";
import { Permission, SecurityArea } from "../../auth/index.ts";
import { UnauthorizedPage } from "../../pages/UnauthorizedPage/UnauthorizedPage.tsx";

import { EngagementRouteGuard } from "./EngagementRouteGuard.tsx";
import { LoadingContent } from "./LoadingContent.tsx";
import { ProjectRouteGuard } from "./ProjectRouteGuard.tsx";

interface Props {
    securityArea?: SecurityArea;
    hasAny?: Permission[];
    render: ReactNode;
    applicationArea?: string;
}

export const ApplicationsRouteGuard: FunctionComponent<Props> = ({ securityArea, render, applicationArea }) => {
    const { engagementId, projectId } = useParams();
    const { data: applications, isLoading: isApplicationsLoading } = useApplications(engagementId || "", projectId, !!engagementId || !!projectId);
    let hasApplicationAccess: boolean = false;

    if (applications) {
        const selectedApplication = applications.find(a => a.urn === applicationArea);
        if (selectedApplication) {
            hasApplicationAccess = selectedApplication.enabled || false;
        }
    }

    if (import.meta.env.VITE_BYPASS_AUTH === "true" || import.meta.env.VITE_MOCK_ENTIRE_BACKEND === "true") {
        return <>{render}</>;
    }

    if (isApplicationsLoading) {
        return <LoadingContent />;
    } else if (hasApplicationAccess) {
        if (!projectId) {
            return <EngagementRouteGuard securityArea={securityArea} render={render} />;
        } else {
            return <ProjectRouteGuard securityArea={securityArea} render={render} />;
        }
    } else {
        return <UnauthorizedPage />;
    }
};
